<template>
	<refresh-loading-bar v-if="pullDistance > 0" :spinnerPosition="spinnerPosition" />

	<div @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
		<router-view />
	</div>
	<!-- <router-view /> -->
	<!-- 기존 로딩 상태로 표시되는 컴포넌트 (기존 방식) -->
	<loading-bar v-if="store.state.loading?.isLoading" />

	<!-- 공통 alert message modal -->
	<popup-alert v-if="store.state.alert.isPopup" />
	<popup-confirm v-if="store.state.confirm.isPopup" />
	<popup-custom-confirm v-if="store.state.customConfirm.isPopup" />
</template>

<script setup>
import { watch, onBeforeMount } from 'vue';
import store from './store/store';
import PopupAlert from '@/views/ko/popup/PopupAlert.vue';
import PopupConfirm from '@/views/ko/popup/PopupConfirm.vue';
import PopupCustomConfirm from '@/views/ko/popup/PopupCustomConfirm.vue';
import LoadingBar from './components/loading/LoadingBar.vue';
import { usePullToRefresh } from './hooks/pullToRefreshHook';
import RefreshLoadingBar from './components/loading/RefreshLoadingBar.vue';
import { useLanguage } from './hooks/languageHook';
const { pullDistance, spinnerPosition, onTouchStart, onTouchMove, onTouchEnd } = usePullToRefresh();
const { setLanguage } = useLanguage();

onBeforeMount(async () => {
	// await getBeforeCheckLang();
});

watch(
	() => store.state.locales?.lang,
	async (newValue, oldValue) => {
		if (newValue !== oldValue) {
			await setLanguage(newValue);
		}
	},
);

// window.addEventListener('popstate', () => {
//   window.location.reload()

// });
</script>
